import styled, { css } from 'styled-components';
import { inputStyles } from '../../styled/inputs';

export const SelectWrapper = styled.div`
  position: relative;

  svg {
    width: 12px;
    height: 12px;
    position: absolute;
    top: 50%;
    margin-top: -6px;
    right: 12px;
    pointer-events: none;
  }
`;

export const StyledSelect = styled.select`
  ${inputStyles};

  appearance: none;
  width: 100%;

  ${({ $error, theme }) =>
    $error &&
    css`
      border: 4px solid ${theme.palette.errorBorder};
      padding: 5px;
    `}
`;
